import React, { useEffect } from 'react';
import Request from '@hotmart/request';
import { useTranslation } from 'react-i18next';

import { EVENT, MOBILE_SESSION_KEY } from '@/common/constants';
import { NotificationWrapper } from '@/components/notification';
import { useEventAgent } from '@/common/hooks/useEventAgent';
import { useMutation } from '@tanstack/react-query';

function FinishFlow() {
  const { t } = useTranslation();
  const { trackEvent } = useEventAgent();
  const startedOnMobile = sessionStorage.getItem(MOBILE_SESSION_KEY) === 'true';
  const mutation = useMutation({
    mutationFn: () => {
      return Request('biometric.send.review', {});
    },
    onSuccess: () => {
      trackEvent(EVENT.REGISTRATION_COMPLETED_SUCCESSFULLY_PAGE_VIEW);
    }
  });

  useEffect(() => {
    mutation.mutate();
  }, []);

  return (
    <NotificationWrapper
      title={t('statusDocument.finishFlow.title')}
      status="finished"
    >
      {startedOnMobile && <p className="mb-2 text-center text-3 text-gray-900">{t('statusDocument.finishFlow.details')}</p>}
    </NotificationWrapper>
  );
}

export default FinishFlow;
